import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ContentHeaderKey } from "src/app/constants/content-header";
import { AgentCompany } from "src/app/models/agent";

import { CompanyResources, ResourceLink } from "src/app/models/resource-link";
import { AgentCRMService } from "src/app/services/agent-crm.service";

@Component({
    selector: 'mwp-agent-resourcs-company',
    templateUrl: './company.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AgentResourcesCompanyComponent implements OnInit {
    public companySearchForm: FormGroup;
    public apiUrl = ContentHeaderKey.CounselorCompanyLevel;

    public resources: ResourceLink[];

    constructor(
        private agentCRMService: AgentCRMService,
        private formBuilder: FormBuilder,
    ) {
    }

    ngOnInit(): void {

        this.agentCRMService.getCompanyResourcesByID().subscribe((response: CompanyResources) => {
            let companyID: number;
            let companyName: string;
            if (response) {
                this.resources = response.company;
                companyID = response.companyID;
                companyName = response.companyName;
            }

            this.companySearchForm = this.formBuilder.group({
                companyName: [companyName, Validators.required],
                companyID: [companyID, Validators.required],
            });
        });
    }

    public getCompanyResources(company: AgentCompany) {
        this.agentCRMService.getCompanyResourcesByID(company).subscribe((response: CompanyResources) => {
            this.resources = response.company;
        });
    }
}